module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      操作记录\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('aside'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentBox"
    }
  }, [_c('div', {
    staticClass: "mui-content"
  }, [_c('ul', {
    staticClass: "common-list-box"
  }, _vm._l((this.listArrs.content), function(item) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item-info remark"
    }, [_c('div', {
      staticClass: "item-top"
    }, [_vm._v("\n                  发帖截图：\n                  "), _c('img', {
      staticStyle: {
        "max-height": "135px"
      },
      attrs: {
        "src": item.img_fatie,
        "alt": "发帖截图",
        "width": "135"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("提交时间：\n                    " + _vm._s(item.SetTime) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("审核时间：\n                    " + _vm._s(item.CheckTime) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("状态：\n                    " + _vm._s(item.State) + "\n                  ")])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v("\n                " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.pageCount) + "\n                "), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.pageCount
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63704724","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/vpsrecord.vue
// module id = Ll5Z
// module chunks = 1